import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import { format } from 'fecha';
import { Button, Card, CardActionArea, CardActions, CardContent, CircularProgress, Grid, List, ListItem, ListItemText, LinearProgress } from '@material-ui/core'
import 'office-ui-fabric-react/dist/css/fabric.css'
import { ComboBox, IIconProps, Panel, PanelType } from 'office-ui-fabric-react';
import IViewPostulante from '../../view-interfaces/IViewPostulante';
import { useStyles } from '../Inicio/InicioEstudiante.logic';
import Draggable from 'react-draggable';
import Alert from '@material-ui/lab/Alert/Alert';
import { ObtieneReglaBecasLogic } from '../../view-model/Arancel/Arancel.logic';

type Props = {
    pagado: any;
    estado: boolean;
    onClick: any;
}
const DetallePagado: React.FC<Props> = ({ pagado, onClick, estado }) => {
    const location = useLocation();

    function transformarMiles(valor: string) {
        const valor1 = valor + "";
        let retornar = "0";
        var splitValor;
        if (valor !== "0") {
            if (valor1.indexOf('.') === -1) {
                retornar = parseInt(valor1).toLocaleString()
            } else {
                splitValor = valor1.split('.');
                retornar = parseInt(splitValor[0]).toLocaleString()
            }
        }
        return retornar;
    }
    return (

        <>
            <Panel
                isOpen={estado}
                type={PanelType.medium}
                hasCloseButton={true}
                onDismiss={() => { onClick(false) }}
            /* 
            headerText={"Beca Matricula"} */
            >
                <div>
                    <br></br>

                    {
                        <div>
                            <h5>Pagado</h5>

                            <div className="payment-selection mb-2" >
                                <h3 className="payment-selection__title" > Detalle Pago </h3>
                                <table className={"payment-selection__table table w-50"}>
                                    <thead>
                                        <th style={{ whiteSpace: 'nowrap' }} className="text-center w-100" >Tipo Pago </th>
                                        <th className="text-center w-20" > Fecha  </th>
                                        < th className="text-center w-30" >Monto </th>
                                    </thead>
                                    <tfoot>
                                        {
                                            pagado.listadoWebpay.map((e: any) => {
                                                return (
                                                    <tr>
                                                        <td className="w-30 text-center" > WebPay </td>
                                                        <td style={{ whiteSpace: 'nowrap' }} className="text-center w-20" > {`${e.fecha.replace('T', ' ')}`} </td>
                                                        <td className="text-center w-20 " > {`$${transformarMiles(Math.round(parseFloat((e.monto))).toString())}`} </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        {
                                            pagado.listadoFactura.map((e: any) => {
                                                return (
                                                    <tr>
                                                        <td className="w-30 text-center" > Factura </td>
                                                        <td style={{ whiteSpace: 'nowrap' }} className="text-center w-20" > {`${e.fecha.replace('T', ' ')}`} </td>
                                                        <td className="text-center w-20 " > {`$${transformarMiles(Math.round(parseFloat((e.monto))).toString())}`} </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        {
                                            pagado.listadoTransferenciaBancarias.map((e: any) => {
                                                return (
                                                    <tr>
                                                        <td className="w-30 text-center" > Transferencia </td>
                                                        <td style={{ whiteSpace: 'nowrap' }} className="text-center w-20" > {`${e.fechaTransaccion.replace('T', ' ')}`} </td>
                                                        <td className="text-center w-20 " > {`$${transformarMiles(Math.round(parseFloat((e.montoPagado))).toString())}`} </td>
                                                        <td className="text-center w-20 " > {`${e.estado ?? ""}`} </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        {/* {
                                            pagado.desctPagoContado != null && pagado.desctPagoContado != undefined ?
                                                <tr>
                                                    <td className="w-30 text-center" > Desct. Pago Contado </td>
                                                    <td style={{ whiteSpace: 'nowrap' }} className="text-center w-20" > {`${pagado.desctPagoContado.fecha.replace('T', ' ')}`} </td>
                                                    <td className="text-center w-20 " > {`$${transformarMiles(Math.round(parseFloat((pagado.desctPagoContado.montoCLP))).toString())}`} </td>
                                                </tr>
                                                :
                                                ""
                                        } */}
                                    </tfoot>
                                </table>
                            </div >
                        </div>
                    }
                </div>
            </Panel >
        </>
    );
}

export default DetallePagado;
